import { render, staticRenderFns } from "./CollectionImageIndex.vue?vue&type=template&id=1d562ec8&"
import script from "./CollectionImageIndex.vue?vue&type=script&lang=js&"
export * from "./CollectionImageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports